import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";

import * as serviceWorker from "./serviceWorker";

import {HashRouter as Router} from "react-router-dom";
import "./OMS/assets/base.scss";
import Main from "./OMS/Pages/Main";
import configureStore from "./OMS/config/configureStore";
import {Provider} from "react-redux";
import Auth0ProviderWithHistory from "./auth/auth0-provider-with-history";

const store = configureStore();
const rootElement = document.getElementById("root");

const renderApp = (Component) => {
    ReactDOM.render(
        <Provider store={store}>
            <Router>
                <Auth0ProviderWithHistory>
                    <Component/>
                </Auth0ProviderWithHistory>
            </Router>
        </Provider>,
        rootElement
    );
};

renderApp(Main);

if (module.hot) {
    module.hot.accept("./OMS/Pages/Main", () => {
        const NextApp = require("./OMS/Pages/Main").default;
        renderApp(NextApp);
    });
}
serviceWorker.unregister();
